import { Component } from '@angular/core';
import { SiteFooterComponent } from '../site-footer/site-footer.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss'],
  standalone: true,
  imports: [SiteFooterComponent, SiteHeaderComponent, RouterModule],
})
export class SiteLayoutComponent {}
